import { combineReducers } from 'redux';
import adaptiveMatchingReducer from './adaptiveMatchingReducer';
import auditEventsReducer from './auditEventsReducer';
import blockingConfigReducer from './blockingConfigReducer';
import clusterReducer from './clusterReducer';
import customFieldsReducer from './customFieldsReducer';
import customMetricsReducer from './customMetricsReducer';
import dataProfileReducer from './dataProfileReducer';
import deterMatchingReducer from './deterMatchingReducer';
import entityReducer from './entityReducer';
import fieldsReducer from './fieldsReducer';
import fieldValueIndexesReducer from './fieldValueIndexesReducer';
import identifierDomainsReducer from './identifierDomainsReducer';
import jobEntriesReducer from './jobEntriesReducer';
import loggedPairsReducer from './loggedPairsReducer';
import operationsReducer from './operationsReducer';
import performanceReducer from './performanceMetricsReducer';
import permissionsReducer from './permissionsReducer';
import probMatchingReducer from './probMatchingReducer';
import recordLinksReducer from './recordLinksReducer';
import reportsReducer from './reportsReducer';
import rolesReducer from './rolesReducer';
import searchReducer from './searchReducer';
import sessionReducer from './sessionReducer';
import singleBestRecordReducer from './singleBestRecordReducer';
import stringComparatorsReducer from './stringComparatorsReducer';
import systemConfigReducer from './systemConfigReducer';
import transformFunctionsReducer from './transformFunctionsReducer';
import userFilesReducer from './userFilesReducer';
import usersReducer from './usersReducer';
import Constants from 'src/actions/types';
import valueMergeOperationsReducer from './valueMergeOperationsReducer ';

const appReducer = combineReducers({
  adaptiveMatching: adaptiveMatchingReducer,
  auditEvents: auditEventsReducer,
  blockingConfig: blockingConfigReducer,
  clusterClassification: clusterReducer,
  customFields: customFieldsReducer,
  customMetrics: customMetricsReducer,
  dataProfiles: dataProfileReducer,
  deterMatching: deterMatchingReducer,
  domains: identifierDomainsReducer,
  entities: entityReducer,
  fields: fieldsReducer,
  fieldValueIndexes: fieldValueIndexesReducer,
  jobEntries: jobEntriesReducer,
  loggedPairs: loggedPairsReducer,
  operations: operationsReducer,
  performanceMetrics: performanceReducer,
  permissions: permissionsReducer,
  probMatching: probMatchingReducer,
  recordLinks: recordLinksReducer,
  reports: reportsReducer,
  roles: rolesReducer,
  session: sessionReducer,
  search: searchReducer,
  sbrConfig: singleBestRecordReducer,
  stringComparators: stringComparatorsReducer,
  systemConfig: systemConfigReducer,
  transformFunctions: transformFunctionsReducer,
  userFiles: userFilesReducer,
  users: usersReducer,
  valueMergeOperations: valueMergeOperationsReducer
});

const rootReducer = (state, action) => {
  if (action.type === Constants.SESSION_LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
